angular.module('TetherApp').factory(
    'giftWithPurchaseService',
    [
        '$http',
        function ($http) {

            let randomString = function randomString(length, chars) {
                let result = '';
                for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
                return result;
            };

            let indexGiftWithPurchase = function (page) {
                let uri = '/api/v1/experience/gift-with-purchase/' +
                    randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                if (page != undefined) {
                    uri += '?page=' + page;
                }
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let storeGiftWithPurchase = function (data) {
                return $http.post(
                    '/api/v1/experience/gift-with-purchase',
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    })
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let updateGiftWithPurchase = function (data) {
                let uri = '/api/v1/experience/gift-with-purchase/' + data.experience.eid;
                return $http.put(
                    uri,
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let deleteGiftWithPurchase = function (giftWithPurchaseId) {
                let uri = '/api/v1/experience/gift-with-purchase/' + giftWithPurchaseId + '/' +
                    randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                // console.log('In delete');
                return $http.delete(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    })
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let drawWinners = function (giftWithPurchaseId, data) {
                let uri = '/api/v1/experience/gift-with-purchase/' + giftWithPurchaseId + '/draw-winners';
                return $http.post(
                    uri,
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let confirmWinners = function (giftWithPurchaseId, data) {
                let uri = '/api/v1/experience/gift-with-purchase/' + giftWithPurchaseId + '/confirm-winners';
                return $http.post(
                    uri,
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let getPrizePools = function (giftWithPurchaseId, data) {
                let uri = '/api/v1/experience/gift-with-purchase/' + giftWithPurchaseId + '/prize-pool';
                return $http.post(
                    uri,
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let getNewEntryForValidation = function (giftWithPurchaseId, data) {
                let uri = '/api/v1/experience/gift-with-purchase/' + giftWithPurchaseId + '/entry-for-validation/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                return $http.get(uri, {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: data
                }).then(function (response) {
                    return response.data;
                });
            };

            let getEntryForValidation = function (giftWithPurchaseId, entry) {
                let uri = '/api/v1/experience/gift-with-purchase/' + giftWithPurchaseId + '/entry-for-validation/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    ) + '?entry=' + entry;
                return $http.get(uri, {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }).then(function (response) {
                    return response.data;
                });
            };

            let postEntryForValidation = function (giftWithPurchaseId, data) {
                let uri = '/api/v1/experience/gift-with-purchase/' + giftWithPurchaseId + '/entry-for-validation/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );

                return $http.post(
                    uri,
                    data,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let getMatchingImages = function (data) {
                return $http.post('/api/v1/experience/gift-with-purchase/matching-images', { 'entry_images': data }, {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }).then(function (response) {
                    return response.data;
                });
            };

            let postRelockEntry = function (giftWithPurchaseId, entryEid) {
                let uri = '/api/v1/experience/gift-with-purchase/' + giftWithPurchaseId + '/entry-for-validation/' + entryEid + '/relock';

                return $http.put(uri, [], {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }).then(function (response) {
                    return response.data;
                });
            };

            // START: REPORTING
            let statsGiftWithPurchase = function (giftWithPurchaseId, params) { 
                let uri = '/api/v1/experience/gift-with-purchase/' + giftWithPurchaseId + '/get-report/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    )
                    + '?report_name=stats&report_type=json';
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' },
                        params: params
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let graphGiftWithPurchase = function (giftWithPurchaseId) {
                let uri = '/api/v1/experience/gift-with-purchase/' + giftWithPurchaseId + '/get-report/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    )
                    + '?report_name=graph&report_type=json';
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };
            // END: REPORTING
            return {
                indexGiftWithPurchase: indexGiftWithPurchase,
                storeGiftWithPurchase: storeGiftWithPurchase,
                updateGiftWithPurchase: updateGiftWithPurchase,
                deleteGiftWithPurchase: deleteGiftWithPurchase,
                drawWinners: drawWinners,
                confirmWinners: confirmWinners,
                getPrizePools: getPrizePools,
                getNewEntryForValidation: getNewEntryForValidation,
                getEntryForValidation: getEntryForValidation,
                postEntryForValidation: postEntryForValidation,
                getMatchingImages: getMatchingImages,
                postRelockEntry: postRelockEntry,
                statsGiftWithPurchase: statsGiftWithPurchase,
                graphGiftWithPurchase: graphGiftWithPurchase,
            };

        }
    ]
);
